<template>
  <basic-container>
      <div>
          小区:
          <el-select v-model="communityId" placeholder="请选择小区" clearable @change="changeCommunity">
              <el-option 
                    v-for="item in communityList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
              ></el-option>
          </el-select>
      </div>
      <div v-if="keyList.length>0" style="padding:2rem 0;">

          <div v-for="(itemIndex,index) in keyList" 
                style="border-bottom:1px solid #ccc;padding:1rem 0;"
                        :key="index">
            <div style="display:flex;">
                <div style="width:4%">{{itemIndex}}</div>

                <div style="width:24%;"
                    v-for="item in elevatorList[itemIndex]"
                    :key="item.id"
                >
                    <div style="overflow:hidden;">
                            <div style="float:left;">
                                <div>
                                    <img src="/img/elevator_icon.png" alt="" style="width:50px">
                                </div>
                                <div>{{item.elevatorName}}</div>
                            </div>
                            <div style="float:left;margin-left:.5rem;">
                                <div>运行状态:{{getStatus(item.status)}}</div>
                                <div>当前楼层:{{item.currentFloor}}</div>
                                <div>层内人员{{item.usingHumanNum}}</div>
                                <div>累计运行:{{item.keepWorkDays}}天</div>
                                <div>累计运行:{{item.keepWorkTimes}}次</div>
                            </div>
                    </div>
                </div>

            </div>
          </div>

      </div>
      <div v-else style="width:100%;padding:5rem 0;text-align:center;">
          暂无数据
      </div>
    <!-- <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.elevatorworkstatus_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud> -->
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update, getListByCommunity, getCommunityTree } from '@/api/v4ward/elevator/elevatorworkstatus';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        column: [
          {
            label: '主键，小区ID',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入主键，小区ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '电梯id',
            prop: 'elevatorId',
            rules: [
              {
                required: true,
                message: '请输入电梯id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '电梯运行状态',
            prop: 'workStatus',
            rules: [
              {
                required: true,
                message: '请输入电梯运行状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '当前楼层',
            prop: 'currentFloor',
            rules: [
              {
                required: true,
                message: '请输入当前楼层',
                trigger: 'change',
              },
            ],
          },
          {
            label: '当前轿内人员',
            prop: 'usingHumanNum',
            rules: [
              {
                required: true,
                message: '请输入当前轿内人员',
                trigger: 'change',
              },
            ],
          },
          {
            label: '类型运行天数',
            prop: 'keepWorkDays',
            rules: [
              {
                required: true,
                message: '请输入类型运行天数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '累计运行次数',
            prop: 'keepWorkTimes',
            rules: [
              {
                required: true,
                message: '请输入累计运行次数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注',
            prop: 'remark',
            rules: [
              {
                required: true,
                message: '请输入备注',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
      communityList: [],
      communityId:'',
      elevatorList: [],
      keyList:[]
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.elevatorworkstatus_add, false),
        viewBtn: this.vaildData(this.permission.elevatorworkstatus_view, false),
        delBtn: this.vaildData(this.permission.elevatorworkstatus_delete, false),
        editBtn: this.vaildData(this.permission.elevatorworkstatus_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created(){
      getCommunityTree().then((res)=>{
          console.log(res);
          this.communityList = res.data;
          console.log(this.communityList);
            this.communityId = this.communityList[0].id;
            getListByCommunity({communityId:this.communityList[0].id}).then((res)=>{
                
                console.log("getListByCommunity======>",res);
                this.elevatorList = res.data;
                // this.keyList = Object.keys(this.elevatorList);
                this.keyList = [];
                for(let i in this.elevatorList){
                    // console.log(i); //a,b,c,d
                    this.keyList.push(i);
                }
                this.keyList = this.keyList.reverse();
                console.log(this.keyList);


            });
      });


      
  },
  methods: {
      getStatus(status){
          if(parseInt(status)==1){
              return '正常';
          }else{
              return '异常';
          }
      },
      changeCommunity(val){
        console.log(val);
        getListByCommunity({communityId:val}).then((res)=>{
            
                console.log("getListByCommunity======>",res);
                this.elevatorList = res.data;
                // this.keyList = Object.keys(this.elevatorList);
                this.keyList = [];
                for(let i in this.elevatorList){
                    // console.log(i); //a,b,c,d
                    this.keyList.push(i);
                }
                this.keyList = this.keyList.reverse();
                console.log(this.keyList);


        });
      },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style>
</style>
